<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                        <v-card>
                            <v-card-title
                                class="text-subtitle-1 font-weight-bold bg-blue-grey-lighten-4 mb-0"
                                >Others Info</v-card-title
                            >
                            <v-card-text class="pa-3">
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="sale_order_multiple_id.value.value"
                                            :items="getSaleOrderList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            :error-messages="sale_order_multiple_id.errorMessage.value"
                                            autocomplete="off"
                                            @update:model-value="onSaleInvoiceDeliveryChange"
                                            :disabled="requisitionDisable"
                                            :loading="saleInvoiceLoading"
                                            multiple
                                            chips
                                            clearable
                                        >
                                            <template #label>
                                                Sale Orders
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-date-input
                                            label="Gate Pass Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="gate_pass_date.value.value"
                                            :error-messages="gate_pass_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Gate Pass Date
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-date-input>

                                      <!-- <v-autocomplete 
                                            variant="outlined" 
                                            density="compact"
                                            bg-color="grey-lighten-4" 
                                            v-model="customer_id.value.value"
                                            @update:model-value="onCustomerChange"
                                            :items="getCustomerMapList"
                                            :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"
                                            item-value="customer_id"
                                            :error-messages="customer_id.errorMessage.value"
                                            autocomplete="off" 
                                            clearable
                                            >
                                            <template #label>
                                                Buyer Name
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete> -->

                                         <!-- <v-autocomplete 
                                            label="Port of Loading" 
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="from_port_id.value.value"
                                            :items="getPortList"
                                            :item-title="(item) => `${item.name}`" 
                                            item-value="id"
                                            @update:model-value="onFromPortChange"
                                            :error-messages="from_port_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template v-slot:selection="{ props, item }">
                                                <div class="d-flex align-center noto-color-emoji-regular"
                                                    v-bind="props"
                                                    color="primary"
                                                    variant="tonal"
                                                >
                                                {{ item?.raw.name }}, 
                                                {{ item?.raw.country?.name }}
                                                <span class="noto-color-emoji-regular">{{ item?.raw.country?.emoji }}</span>
                                                </div>
                                            </template>
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" v-slot=""  :title="null">
                                                    <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                        <div class="flex-grow-1">
                                                            <span>{{ item?.raw.name }}</span>
                                                        </div>
                                                        <div class="text-grey text-caption">
                                                            {{ item?.raw.country?.name }}
                                                            <span class="mr-2 text-lg noto-color-emoji-regular">{{ item?.raw.country?.emoji }}</span>
                                                        </div>
                                                    </div>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>

                                         <v-autocomplete 
                                            label="Port of Destination" 
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="to_port_id.value.value"
                                            :items="getPortList"
                                            :item-title="(item) => `${item.name}`" 
                                            @update:model-value="onToPortChange"
                                            item-value="id"
                                            :error-messages="to_port_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template v-slot:selection="{ props, item }">
                                                <div class="d-flex align-center noto-color-emoji-regular"
                                                    v-bind="props"
                                                    color="primary"
                                                    variant="tonal"
                                                >
                                                {{ item?.raw.name }}, 
                                                {{ item?.raw.country?.name }}
                                                <span class="noto-color-emoji-regular">{{ item?.raw.country?.emoji }}</span>
                                                </div>
                                            </template>
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" v-slot=""  :title="null">
                                                    <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                        <div class="flex-grow-1">
                                                            <span>{{ item?.raw.name }}</span>
                                                        </div>
                                                        <div class="text-grey text-caption">
                                                            {{ item?.raw.country?.name }}
                                                            <span class="mr-2 text-lg noto-color-emoji-regular">{{ item?.raw.country?.emoji }}</span>
                                                        </div>
                                                    </div>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete> -->

                                        <v-text-field
                                            label="Driver Name"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="driver_name.value.value"
                                            :error-messages="driver_name.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Driver Name
                                                <span class="text-red-accent-4"></span>
                                            </template>
                                        </v-text-field>

                                        <v-text-field
                                            label="Transporter Name"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="transporter_name.value.value"
                                            :error-messages="transporter_name.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Vehicle No"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="vehicle_no.value.value"
                                            :error-messages="vehicle_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Mobile No"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="mobile_no.value.value"
                                            :error-messages="mobile_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Container No"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="container_no.value.value"
                                            :error-messages="container_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Lock No"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="lock_no.value.value"
                                            :error-messages="lock_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                        <!-- <v-autocomplete 
                                            label="Currency"
                                            density="compact" 
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            :items="getLatestExchangeRateList"
                                            v-model="rate_id.value.value"
                                            disabled
                                            :item-title="item => item && item.currency_name"                                            
                                            item-value="id"
                                            @update:model-value="onCurrencyChange"
                                            :error-messages="rate_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                        </v-autocomplete> -->

                                        <!-- <v-text-field
                                            label="Currency Rate"
                                            density="compact" 
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="currency_rate.value.value"
                                            :error-messages="currency_rate.errorMessage.value" 
                                            autocomplete="off"
                                            :disabled="true" clearable>
                                        </v-text-field> -->

                                         <v-text-field
                                            label="Gate Passed By"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Gate Passed By Mobile"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by_mobile.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                </v-col>

                <v-col md="9" cols="12">
                        <v-card :loading="itemsLoading">
                            <v-card-title
                            class="text-subtitle-1 font-weight-bold bg-blue-grey-lighten-4 mb-0"
                            >
                                Item Info
                            </v-card-title>

                            <v-card-text class="pa-0">
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                    <!-- Cart Table -->
                                    <v-row>
                                        <v-col>
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                style="min-height: 40vh;"
                                            >
                                            <thead>
                                                <tr>
                                                    <th style="width: 5%">SL</th>
                                                    <th style="min-width: 200px">ORDER NO</th>
                                                    <!-- <th style="min-width: 150px">RECEIVE NO</th> -->
                                                    <th style="min-width: 250px">BUYER</th>
                                                    <th style="min-width: 150px">SHIPMENT MODE</th>
                                                    <th style="min-width: 250px">SHIPPER NAME</th>
                                                    <th style="min-width: 200px">PRODUCT NAME</th>
                                                    <th style="min-width: 150px">CATEGORY</th>
                                                    <th style="min-width: 150px">CALC TYPE</th>
                                                    <th style="min-width: 120px">CBM MEAS.</th>
                                                    <th style="min-width: 120px">ORDER QTY</th>
                                                    <th style="min-width: 120px">QTY</th>
                                                    <th style="min-width: 120px">PRODUCT QTY</th>
                                                    <th style="min-width: 100px">CBM</th>
                                                    <th style="min-width: 100px">RATE</th>
                                                    <th style="min-width: 120px">AMOUNT</th>
                                                    <th style="min-width: 200px">REMARKS</th>
                                                    <!-- <th style="min-width: 80px">ACTION</th> -->
                                                </tr>
                                                </thead>
                                                <tbody >
                                                    <tr v-for="(detail, index) in cart" :key="index">
                                                        <td class="text-center py-2">{{ index + 1 }}</td>

                                                        <td class="text-center py-2">
                                                            <v-autocomplete
                                                                variant="outlined"
                                                                density="compact"
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.sale_order_master_id"
                                                                :items="getSaleOrderList"
                                                                :item-title="(item) => `${item.code}`"
                                                                item-value="id"
                                                                autocomplete="off"
                                                                disabled
                                                                :loading="saleInvoiceLoading"
                                                                hide-details
                                                                clearable
                                                            >
                                                                <template #label>
                                                                    Sale order 
                                                                    <span class="text-red-accent-4">*</span>
                                                                </template>
                                                            </v-autocomplete>
                                                        </td>

                                                        <!-- <td class="py-2">
                                                            <v-text-field 
                                                                label="Receive No" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                v-model="detail.receive_no"
                                                                hide-details
                                                                autocomplete="off"
                                                                disabled
                                                                clearable>
                                                            </v-text-field>
                                                        </td> -->

                                                        <td class="py-2">
                                                            <v-autocomplete 
                                                                variant="outlined" 
                                                                density="compact"
                                                                bg-color="grey-lighten-4" 
                                                                v-model="detail.customer_id"
                                                                :items="getCustomerMapList"
                                                                :item-title="(item) => item.customer.customer_name"
                                                                item-value="customer_id"
                                                                autocomplete="off" 
                                                                hide-details
                                                                disabled
                                                            >
                                                                <template #label>
                                                                    Buyer Name
                                                                    <span class="text-red-accent-4"></span>
                                                                </template>

                                                            </v-autocomplete>
                                                        </td>

                                                        <td class="py-2">
                                                            <v-autocomplete 
                                                                label="Shipment Mode" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.shipment_mode"
                                                                :items="getShipmentMode"
                                                                :item-title="(item) => `${item.display_text}`" 
                                                                item-value="name"
                                                                autocomplete="off"
                                                                readonly
                                                                disabled
                                                                hide-details
                                                            >
                                                            </v-autocomplete>
                                                        </td>

                                                        <td class="py-2">
                                                            <v-autocomplete 
                                                                label="Shipper Name"
                                                                density="compact"
                                                                variant="outlined" 
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.supplier_id"
                                                                :items="getCustomerMapList"
                                                                :item-title="(item) => item.customer.customer_name"                                              
                                                                item-value="customer_id"
                                                                autocomplete="off"
                                                                readonly
                                                                disabled
                                                                hide-details
                                                            >
                                                            </v-autocomplete>
                                                        </td>

                                                        <td class="py-2">
                                                            <v-autocomplete
                                                                density="compact"
                                                                variant="outlined"
                                                                v-model="detail.product_id"
                                                                :items="getProductMapList"
                                                                :item-title="(item) => `${item.product?.name}`"
                                                                item-value="product_id"
                                                                label="Product"
                                                                autocomplete="off"
                                                                hide-details
                                                                disabled
                                                                readonly
                                                            >
                                                                <template #append-item>
                                                                    <v-list-item v-if="search && !productExists" @click="createNewProduct(search)">
                                                                        <v-list-item-title>
                                                                            ➕ Add "<strong>{{ search }}</strong>" as new product
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                        </td>
                                                        <td class="py-2">
                                                            <v-select
                                                                density="compact"
                                                                variant="outlined"
                                                                :items="[{title:'Brand', value:'brand'}, {title:'Non-Copy', value:'non_copy'}, {title:'Normal Copy', value:'normal_copy'}, {title:'Copy & Brand', value:'copy_and_brand'}]"
                                                                v-model="detail.category"
                                                                label="Category"
                                                                hide-details
                                                                autocomplete="off"
                                                                disabled
                                                                :error-messages="getDetailError(index, 'category')"
                                                                @blur="validateDetailField(index, 'category', detail.category)"
                                                            />
                                                        </td>

                                                        <td class="py-2" style="width: 160px">
                                                            <v-select
                                                                density="compact"
                                                                variant="outlined"
                                                                :items="[{title:'CBM', value:'cbm'}, {title:'Carton/Bag', value:'ctn'}, {title:'KG', value:'kg'}]"
                                                                v-model="detail.calc_type"
                                                                label="Calc"
                                                                autocomplete="off"
                                                                hide-details
                                                                disabled
                                                                @update:model-value="calculateRow(detail)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.cbm_meas"
                                                                disabled
                                                                label="CBM MEAS."
                                                                width="100px"
                                                                autocomplete="off"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'cbm_meas')"
                                                                @blur="validateDetailField(index, 'cbm_meas', detail.cbm_meas)"
                                                            />
                                                        </td>
                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.order_qty"
                                                                label="Order Qty"
                                                                width="80px"
                                                                disabled
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'qty')"
                                                                @update:model-value="calculateRow(detail)"
                                                                @blur="validateDetailField(index, 'qty', detail.qty)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.qty"
                                                                label="Qty"
                                                                width="80px"
                                                                disabled
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'qty')"
                                                                @update:model-value="calculateRow(detail)"
                                                                @blur="validateDetailField(index, 'qty', detail.qty)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.product_qty"
                                                                label="Product Qty"
                                                                hide-details
                                                                readonly=""
                                                                disabled=""
                                                                :error-messages="getDetailError(index, 'product_qty')"
                                                                @blur="validateDetailField(index, 'product_qty', detail.product_qty)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.cbm"
                                                                label="CBM"
                                                                width="100px"
                                                                hide-details
                                                                disabled
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'cbm')"
                                                                @blur="validateDetailField(index, 'cbm', detail.cbm)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.rate"
                                                                label="Rate"
                                                                width="100px"
                                                                hide-details
                                                                disabled
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.total"
                                                                label="Amount"
                                                                width="120px"
                                                                disabled
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'total')"
                                                                @blur="validateDetailField(index, 'total', detail.total)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.remarks"
                                                                label="Remarks"
                                                                width="200px"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'Total')"
                                                                @blur="validateDetailField(index, 'Total', detail.total)"
                                                            />
                                                        </td>

                                                        <!-- <td class="py-2"> -->
                                                            <!-- <v-btn
                                                                @click="removeDetailRow(index)"
                                                                variant="tonal"
                                                                color="primary"
                                                                disabled
                                                                v-if="index !== cart.length - 1"
                                                            >
                                                                <v-icon
                                                                    color="red"
                                                                    icon="mdi-minus"
                                                                    size="medium"
                                                                ></v-icon>
                                                            </v-btn>

                                                            <v-btn
                                                                @click="addDetailRow"
                                                                variant="tonal"
                                                                color="primary"
                                                                disabled
                                                                v-else
                                                            >
                                                            <v-icon
                                                                color="info"
                                                                icon="mdi-plus"
                                                                size="medium"
                                                            ></v-icon>
                                                            </v-btn> -->

                                                            <!-- <v-icon
                                                                @click="removeDetailRow(index)"
                                                                color="red"
                                                                icon="mdi-minus"
                                                                size="medium"
                                                                class="btn"
                                                            ></v-icon>
                                                            
                                                            <v-icon
                                                                @click="addDetailRow"
                                                                v-if="index == cart.length - 1"
                                                                color="info"
                                                                icon="mdi-plus"
                                                                size="medium"
                                                                class="ml-2"
                                                                disabled
                                                            ></v-icon> -->
                                                        <!-- </td> -->
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="6">
                                                <v-label class="text-subtitle-1 font-weight-bold mb-1">Address</v-label>
                                                <Ckeditor 
                                                :editor="ClassicEditor" 
                                                v-model="address.value.value" 
                                                :config="editorConfig" 
                                                />
                                            </v-col>

                                            <v-col cols="6">
                                                <v-label class="text-subtitle-1 font-weight-bold mb-1">Description</v-label>
                                                <v-textarea
                                                label="Description"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="remarks.value.value"
                                                :error-messages="remarks.errorMessage.value"
                                                autocomplete="off"
                                                rows="7"
                                                clearable
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-layout class="justify-end">
                                                    <v-btn
                                                    class="bg-grey-darken-1 me-2"
                                                    variant="flat"
                                                    @click="submitForm(0)"
                                                    >DRAFT</v-btn>
                                                    <v-btn
                                                    class="bg-primary"
                                                    variant="flat"
                                                    @click="submitForm(1)"
                                                    >POST</v-btn>
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-card-text>
                        </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, reactive, computed } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import formattedDate from "@/plugins/dateFormatter";

export default {
    components: {
        Ckeditor,
    },
    data: () => ({
        isEntryMode: true,
        panel: [0],
        panel2: [0],
        saleInvoiceLoading: false,
        customerLoading: false,
        itemsLoading: false,
        errorMessages: "",
        visible: false,
        deliveryQtyDisable: false,
        requisitionDisable: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
    }),
    watch: {},
    created() {
         if (this.$store.getters.getBrandList.length === 0) {
            this.$store.dispatch("getBrandList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        //if (this.$store.getters.getSaleOrderList.length === 0) {
            this.saleInvoiceLoading = true;
            this.$store.dispatch("getSaleOrderList",{
                isTrk: true,
                edit_id: this.$route.query.id,
            }).then((res) => {
                this.saleInvoiceLoading = false;
            });
        //}
         if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
        if (this.$store.getters.getSupplierMapList.length === 0) {
            this.$store.dispatch("getSupplierMapList");
        }
        if(this.$store.getters.getPortList.length === 0) {
            this.$store.dispatch('getPortList');
        }
        if (this.$store.getters.getLatestExchangeRateList.length == 0) {this.$store.dispatch('getLatestExchangeRateList')}
    },
    computed: {
        getShipmentMode() {
            return [
                { name: 'by_sea',  display_text: 'By Sea' }, 
                { name: 'by_road',  display_text: 'By Road' }, 
                { name: 'by_air',  display_text: 'By Air' }
            ]
        },
        getSaleOrderList() {
            return this.$store.getters.getSaleOrderList;
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        getSupplierMapList() {
            return this.$store.getters.getSupplierMapList;
        },
        getPortList() {
            return this.$store.getters.getPortList;
        },
        getBrandList() {
            return this.$store.getters.getBrandList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) =>
                item.branch_id == this.$store.getters.getAuthUser.branch_id &&
                item.status == 1
            );
        },
        getLatestExchangeRateList() {
            const rates = this.$store.getters.getLatestExchangeRateList || [];
            return rates.map(rate => ({
                ...rate,
                currency_name: rate.currency ? `${rate.currency.symbol} ${rate.currency.name} (${rate.currency.code})` : 'N/A'
            }));
        },
    },
    methods: {
        formattedDate,
        async onSaleInvoiceDeliveryChange(selectedIds) {
            if (!selectedIds || selectedIds.length === 0) {
                this.cart = [];
                return;
            }

            try {
                this.itemsLoading = true;

                const response = await this.$store.dispatch("getSaleOrderByIds", { sale_orders_id: selectedIds })
                .then((res) => {
                    this.itemsLoading = false;
                    return res;
                });

                this.cart = [];
                
                response?.forEach((saleOrder) => {

                    (saleOrder?.details || []).forEach((item) => {
                        this.cart.push({
                            sale_order_master_id: item.sale_order_master_id || null, 
                            sale_order_detail_id: item.id,
                            product_id: item.product_id,
                            customer_id: saleOrder?.customer_id || null,
                            shipment_mode: saleOrder?.shipment_mode,
                            supplier_id: saleOrder?.supplier_id || null,
                            shipment_name: saleOrder?.shipper_company_name,
                            product_name: item.product?.name || "",
                            product_code: item.product?.code || "",
                            category: item.category || "",
                            calc_type: item.calc_type || "",
                            receive_no: saleOrder?.receive_no,
                            chalan_no: saleOrder?.chalan_no,
                            height: item.height || "",
                            length: item.length || "",
                            width: item.width || "",
                            order_qty: item?.bag || 0,
                            qty: item.bag || 0,
                            product_qty: item.qty || 0,
                            rate: item.rate || 0,
                            total: (item.bag ?? 0) * (item.rate ?? 0),
                            cbm: item.cbm || 0,
                            cbm_meas: item.cbm_meas || 0,
                            remarks: item.remarks || "",
                        });
                    });
                });
                
            } catch (error) {
                console.error("Error loading sale orders:", error);
                this.cart = [];
            }
        },

        async onCustomerChange(id) {
            if (!id) {
                // this.shop_name.value.value = "";
                // this.buyer_phone.value.value = "";
                return;
            }

            const list = this.$store.getters.getCustomerMapList || [];
            let entry = list.find((it) => {
                return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
            });

            let customer = entry ? entry.customer : null;

            if (!customer) {
                try {
                    customer = await this.$store.dispatch("getCustomerById", id);
                } catch (err) {
                    customer = null;
                }
            }

            if (customer) {
                // this.shop_name.value.value = customer.company_name || customer.company_owner_name || "";
                // this.buyer_phone.value.value = customer.mobile || customer.company_mobile || customer.company_phone || customer.phone || "";
            } else {
                // this.shop_name.value.value = "";
                // this.buyer_phone.value.value = "";
            }
        },

        onFromPortChange(val) {
            try { this.from_port_id.value.value = val; } catch (e) {}
            const toVal = this.to_port_id?.value?.value;
            if (val && toVal && val === toVal) {
                try { this.to_port_id.value.value = null; } catch (e) {}
                toast.error("Port of Loading and Port of Destination cannot be the same — destination cleared.");
            }
        },

        onToPortChange(val) {
            try { this.to_port_id.value.value = val; } catch (e) {}
            const fromVal = this.from_port_id?.value?.value;
            if (val && fromVal && val === fromVal) {
                try { this.from_port_id.value.value = null; } catch (e) {}
                toast.error("Port of Destination and Port of Loading cannot be the same — loading cleared.");
            }
        },

        onCurrencyChange(id) {
            const list = this.$store.getters.getLatestExchangeRateList || [];
            let currency = list.find((it) => {
                return it.id == id;
            });
            if(currency) {
                this.currency_rate.value.value = currency.rate || "";

            } else {
                this.currency_rate.value.value = "";
            }
        },

    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                sale_order_multiple_id: yup.array().required().label("Sale Invoice Delivery"),
                driver_name: yup.string().nullable().label("Driver Name"),
                gate_pass_date: yup.string().required().label("Gate pass date")
            }),
        });
        const gate_pass_master_id = useField("gate_pass_master_id");    
        const sale_order_multiple_id = useField("sale_order_multiple_id");
        const gate_pass_date = useField("gate_pass_date");
        const driver_name = useField( "driver_name");
        const transporter_name = useField("transporter_name");

        const rate_id = useField("rate_id");

        const vehicle_no = useField("vehicle_no");
        const mobile_no = useField("mobile_no");
        const container_no = useField("container_no");
        const lock_no = useField("lock_no");

        const status = useField("status");
        
        const remarks = useField("remarks");
        const address = useField("address");
        const requsition_by = useField("requsition_by");
        const requsition_by_mobile = useField("requsition_by_mobile");
        const requsition_by_email = useField("requsition_by_email");
        const errorMessages = ref("");

        const detailErrors = reactive({});

        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";

         const cart = ref([
            {
                product_id: null,
                sale_order_master_id: null,
                sale_order_detail_id: null,
                category: "",
                calc_type: "",
                qty: 0,
                cbm_meas: 0,
                cbm: 0,
                rate: 0,
                total: 0,
                remarks: "",
            },
        ]);

        const addDetailRow = () => {
            cart.value.push({
                product_id: "",
                category: "",
                bag: "",
                qty: "",
                cbm_meas: "",
                cbm: "",
                rate: "",
                total: "",
                remarks: "",
            });
        };

        const removeDetailRow = (index) => {
            if (cart.value.length > 1) {
                cart.value.splice(index, 1);
                delete detailErrors[index];
                const newErrors = {};
                Object.keys(detailErrors).forEach((key) => {
                const idx = parseInt(key);
                if (idx > index) {
                    newErrors[idx - 1] = detailErrors[key];
                } else if (idx < index) {
                    newErrors[idx] = detailErrors[key];
                }
                });
                Object.keys(detailErrors).forEach((key) => delete detailErrors[key]);
                Object.assign(detailErrors, newErrors);
            }
        };

        function calculateRow(row) {
            const bag = Number(row.bag) || 0;
            const qty = Number(row.qty) || 0;
            const rate = Number(row.rate) || 0;

            const L = Number(row.length) / 100 || 0;
            const W = Number(row.width) / 100 || 0;
            const H = Number(row.height) / 100 || 0;

            if (row.calc_type === "cbm") {
                row.cbm_meas = (L * W * H).toFixed(4);
                row.cbm = (row.cbm_meas * qty).toFixed(4);
                row.total = (row.cbm * rate).toFixed(2);
            }

            if (row.calc_type === "ctn") {
                row.cbm_meas = "";
                row.cbm = "";
                row.total = (qty * rate).toFixed(2);
            }

            if (row.calc_type === "kg") {
                row.cbm_meas = "";
                row.cbm = "";
                row.total = (qty * rate).toFixed(2);
            }
        };

        const validateDetailField = (index, field, value) => {
                if (!detailErrors[index]) {
                    detailErrors[index] = {};
                }

                detailErrors[index][field] = "";

                switch (field) {
                    case "product_id":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Product must be needed";
                        } else {
                            const duplicate = cart.value.some((detail, idx) => idx !== index && detail.product_id == value);
                            if (duplicate) {
                            detailErrors[index][field] = "Product must be unique";
                            }
                        }
                        break;

                    case "category":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Category Name must be needed";
                        }
                        break;

                    case "qty":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Quantity must be needed";
                        }
                        break;

                    case "total":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Total must be needed";
                        } 
                        break;
                }
        };

        const getDetailError = (index, field) => {
            return detailErrors[index] && detailErrors[index][field]
            ? [detailErrors[index][field]]
            : [];
        };

        const validateAllDetails = () => {
            let isValid = true;
            cart.value.forEach((detail, index) => {
                validateDetailField(index, "product_id", detail.product_id);
                validateDetailField(index, "category", detail.category);
                validateDetailField(index, "qty", detail.qty);
                validateDetailField(index, "total", detail.total);

                if (detailErrors[index]) {
                Object.values(detailErrors[index]).forEach((error) => {
                    if (error) isValid = false;
                });
                }
            });

            return isValid;
        };

        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.gate_pass_date = formattedDate(gate_pass_date.value.value);
            values.status = currentStatus.value;
            values.cart = cart.value;

            if(values.cart.length === 0){
                toast.error("Please add at least one item to the cart.");
                return;
            }

            store.dispatch("saveUpdateInvGatePass", values).then((response) => {
                resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "gate-pass-record" });
                    }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });

        });
        return {
            submit,
            submitForm,
            gate_pass_master_id,
            sale_order_multiple_id,
            gate_pass_date,
            driver_name,
            transporter_name,
            vehicle_no,
            mobile_no,
            container_no,
            lock_no,
            remarks,
            address,
            cart,
            status,
            rate_id,
            requsition_by,
            requsition_by_mobile,
            requsition_by_email,
            errorMessages,
            buttonText,
            loading,
            addDetailRow,
            removeDetailRow,
            calculateRow,
            detailErrors,
            validateDetailField,
            getDetailError,
            validateAllDetails,
            ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        "heading", "|",
                        "bold", "italic", "underline", "|",
                        "link", "bulletedList", "numberedList", "|",
                        "outdent", "indent", "|",
                        "blockQuote", "|",
                        "undo", "redo",
                    ],
                },
                language: "en",
            },
        };
    },
    mounted() {
        const today = formattedDate(new Date);
        let user = this.$store.getters.getAuthUser;
        this.requsition_by.value.value = this.$store.getters.getAuthUser.full_name;
        this.requsition_by_mobile.value.value = this.$store.getters.getAuthUser.mobile;
        this.requsition_by_email.value.value = this.$store.getters.getAuthUser.email;

        const id = this.$route.query.id;
        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                    .dispatch("getInvGatePassById", id)
                    .then((data) => {
                        // this.requisitionDisable = true;
                        this.isEntryMode = false;
                        let gatePass = data;
                        
                        this.gate_pass_master_id.value.value = gatePass.id;
                        
                        const uniqueSaleOrderIds = [...new Set(
                            (gatePass.details || []).map(detail => detail.sale_order_master_id)
                        )];

                        this.sale_order_multiple_id.value.value = uniqueSaleOrderIds;

                        this.gate_pass_date.value.value = gatePass.gate_pass_date ? new Date(gatePass.gate_pass_date) : new Date();
                        this.rate_id.value.value = gatePass.rate_id;

                        this.driver_name.value.value = gatePass.driver_name;
                        this.transporter_name.value.value = gatePass.transporter_name;
                        this.vehicle_no.value.value = gatePass.vehicle_no;
                        this.mobile_no.value.value = gatePass.mobile_no;
                        this.container_no.value.value = gatePass.container_no;
                        this.lock_no.value.value = gatePass.lock_no;

                        // Populate cart from details
                        this.cart = (gatePass.details || []).map((item) => ({
                            sale_order_master_id: item.sale_order_master_id,
                            sale_order_detail_id: item.sale_order_detail_id,
                            product_id: item.product_id,
                            customer_id: item?.sale_order?.customer_id || null,
                            shipment_mode: item?.sale_order?.shipment_mode,
                            supplier_id: item?.sale_order?.supplier_id,
                            shipper_name: item?.sale_order?.shipper_company_name,
                            category: item?.sale_order_detail?.category || "",
                            calc_type: item?.sale_order_detail?.calc_type || "",
                            height: item.height || "",
                            length: item.length || "",
                            width: item.width || "",
                            order_qty: item?.sale_order_detail?.qty || 0,
                            qty: item.qty || 0,
                            product_qty: item?.sale_order_detail?.qty || 0,
                            rate: item?.sale_order_detail?.rate || 0,
                            total: (item?.qty ?? 0) * (item?.sale_order_detail?.rate ?? 0),
                            cbm: item?.sale_order_detail?.cbm || 0,
                            cbm_meas: item?.sale_order_detail?.cbm_meas || 0,
                            remarks: item.remarks || "",
                            receive_no: item?.sale_order?.receive_no || "",
                        }));

                        this.remarks.value.value = gatePass.remarks;
                        this.address.value.value = gatePass.address;
                        this.$store.commit("UNSET_LOADING");
                    })
                    .catch((error) => {
                        this.$store.commit("UNSET_LOADING");
                        console.error("Failed to fetch gate pass:", error);
                    });
            });
        } else {
            this.isEntryMode = true;
            this.gate_pass_date.value.value = today;
            this.address.value.value = `<p><strong>Mr. Afsar</strong></p>
                <p><strong>H/P:</strong> <span style="color: #00c853;">+8801635096508</span></p>
                <p><strong>DEPO:</strong> Esack Depot Chitta</p>
                <p><strong>Address:</strong> Chittagong</p>
                <p><strong>Forwarder:</strong> A&A Ocean Services</p>`
        }
    },
};
</script>

<style scoped>
.v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
}
.ck-rounded-corners {
    border-radius: 50px !important;
}
</style>